"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _colorUtils = require("../../../shared/colorUtils");
var _jsxRuntime = require("react/jsx-runtime");
var WorkSignifierContainer = _styledComponents.default.div.withConfig({
  displayName: "WorkSignifier__WorkSignifierContainer",
  componentId: "sc-rxw08n-0"
})(["align-items:flex-start;border-radius:", ";display:inline-flex;padding:calc(", " - ", ") calc(", " - ", ");position:relative;background-color:", ";border:", " solid ", ";cursor:pointer;", ""], _globalTokens.globalBorder.radius['2'], _globalTokens.globalSpacing['100'], _globalTokens.globalBorder.width.thick, _globalTokens.globalSpacing['200'], _globalTokens.globalBorder.width.thick, function (_ref) {
  var color = _ref.color;
  return color;
}, _globalTokens.globalBorder.width.thick, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var outline = _ref3.outline;
  return (0, _styledComponents.css)(["", ""], outline && "background-color: transparent;");
});
var WorkSignifierText = _styledComponents.default.div.withConfig({
  displayName: "WorkSignifier__WorkSignifierText",
  componentId: "sc-rxw08n-1"
})(["display:flex;justify-content:center;align-items:center;color:", ";", ";min-width:", ";white-space:nowrap;text-decoration:none;"], function (_ref4) {
  var color = _ref4.color,
    outline = _ref4.outline,
    theme = _ref4.theme;
  return outline ? _globalTokens.globalColor.text.content.main : color;
}, function (props) {
  return props.theme.sys.font.body[2];
}, function (_ref5) {
  var flexWidth = _ref5.flexWidth;
  return flexWidth ? '' : '45px';
});
var WorkSignifier = function WorkSignifier(_ref6) {
  var workId = _ref6.workId,
    name = _ref6.name,
    color = _ref6.color,
    outline = _ref6.outline,
    onClick = _ref6.onClick,
    flexWidth = _ref6.flexWidth;
  var backgroundColor = color || _globalTokens.globalColor.id['7'];
  var textColor = (0, _colorUtils.getTextColor)(backgroundColor, (0, _styledComponents.useTheme)());
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(WorkSignifierContainer, {
    outline: outline,
    color: backgroundColor,
    onClick: onClick,
    title: name,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WorkSignifierText, {
      color: textColor,
      outline: outline,
      flexWidth: flexWidth,
      children: workId
    })
  });
};
var _default = exports.default = WorkSignifier;